export function APIBaseLink () {
    const link = "https://mycommunityfl.com";
    // const link = "http://localhost:8000";
    return link;
}
